export default __webpack_public_path__ + "static/media/disable2.2d493776.png";